module.exports = "<div class=\"review-card well well-review flex-height-sm\" ng-include src=\"view\">\r\n\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/customer-reviews/cards/review-card-template.html
 ** module id = 916
 ** module chunks = 1
 **/